import styled from 'styled-components';
import { Checkbox as MuiCheckbox } from '@material-ui/core';

export const Checkbox = styled(MuiCheckbox)`
    &.Mui-checked {
        color: ${({ theme }) => theme.palette.primary.main};
    }

    .MuiSvgIcon-root {
        font-size: 1.5rem;
    }
`;
